import { useCallback, useMemo } from "react";
import { mutate } from "swr";

import { organizationEndpoints } from "@api/Endpoints";
import { putData } from "@hooks/usePutData";

export function useUpdateOrganization() {
  const updateOrganization = useCallback(
    async <T>(organizationId: string, fieldName: string, request: T) => {
      const url = organizationEndpoints.update(organizationId, fieldName);

      const result = await putData<T>(url, request);

      const getOrganizationUrl =
        organizationEndpoints.getOrganizationById(organizationId);
      await mutate(getOrganizationUrl);

      return result;
    },
    []
  );

  const updateName = useCallback(
    async (organizationId: string, name: string) => {
      return await updateOrganization(organizationId, "name", { name: name });
    },
    [updateOrganization]
  );

  const updateType = useCallback(
    async (organizationId: string, type: string) => {
      return await updateOrganization(organizationId, "type", { type: type });
    },
    [updateOrganization]
  );

  const updateStatus = useCallback(
    async (organizationId: string, status: string) => {
      return await updateOrganization(organizationId, "status", {
        status: status
      });
    },
    [updateOrganization]
  );

  const updateCountry = useCallback(
    async (organizationId: string, countryCode: string) => {
      return await updateOrganization(organizationId, "country", {
        countryCode: countryCode
      });
    },
    [updateOrganization]
  );

  return useMemo(
    () => ({ updateName, updateType, updateStatus, updateCountry }),
    [updateCountry, updateName, updateStatus, updateType]
  );
}
